var _style, _g, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReleasedDeliveryDateExceeded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#80CE2B;stroke-width:2;stroke-linecap:round;}\n\t.st1{fill:none;stroke:#C6C6C6;stroke-width:2;}\n\t.st2{fill:#C6C6C6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    className: "st0",
    width: 16,
    height: 16
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 9,
    cy: 9,
    r: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.9,5.7c0.1-0.2,0-0.5-0.2-0.6c-0.2-0.2-0.4-0.1-0.6,0.1l-4,3.4C6.1,8.8,6,9,6.1,9.2c0.1,0.2,0.2,0.3,0.5,0.3 h1.7l-1.2,2.8c-0.1,0.2,0,0.5,0.2,0.6c0.2,0.2,0.5,0.2,0.6,0l3.9-3.5c0.2-0.2,0.2-0.3,0.2-0.6c-0.1-0.2-0.2-0.3-0.5-0.3H9.7 L10.9,5.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleasedDeliveryDateExceeded);
export default __webpack_public_path__ + "static/media/released_delivery_date_exceeded.2927bae89ed697189bbf3f02acd951ef.svg";
export { ForwardRef as ReactComponent };